import type { NamespaceSchema } from './types';

// Field paths match apps/web/src/lib/cms/car-settings.ts. Only `per_page`
// is consumed today (cars-listing pagination); other fields are
// speculative — saved values are inert until apps/web wires them.

export const carSettings: NamespaceSchema = {
  namespace: 'car-settings',
  label: 'Car listing rules',
  description: 'Storefront /cars behaviour. Pagination is wired; map / filter knobs are not yet read by the storefront.',
  sections: [
    {
      label: 'Pagination (consumed)',
      fields: [
        { kind: 'number', key: 'per_page', label: 'Cars per page', default: 12, min: 1, max: 60, description: 'Server-side page size on /cars. Read by apps/web/src/lib/cms/car-settings.ts.' },
      ],
    },
    {
      label: 'Map defaults (not yet consumed)',
      description: 'Saved values are inert until the cars listing wires them in.',
      fields: [
        { kind: 'number', key: 'map_lat_default', label: 'Default map latitude', step: 0.0001, placeholder: '33.5731' },
        { kind: 'number', key: 'map_lng_default', label: 'Default map longitude', step: 0.0001, placeholder: '-7.5898' },
        { kind: 'number', key: 'map_zoom_default', label: 'Default map zoom', default: 6, min: 1, max: 20 },
      ],
    },
  ],
};
